import { request } from './http.js'

export async function fetchSyncLogs({ job = '', status = '', page = 1, pageSize = 20 } = {}) {
  const params = new URLSearchParams()
  if (job) params.set('job', job)
  if (status) params.set('status', status)
  params.set('page', String(page))
  params.set('pageSize', String(pageSize))
  return request(`/api/sync-logs?${params.toString()}`)
}
